export default __webpack_public_path__ + "static/media/singpass_logo_fullcolours-1.667eeab3.svg";